import { Tag } from "antd";
import React from "react";

export const ZWonTag: React.FC = () => {
	return (
		<Tag className="ml-3 px-2 py-0 border-green-6" color="green">
			Won
		</Tag>
	);
};

export const ZLostTag: React.FC = () => {
	return (
		<Tag className="ml-3 px-2 py-0 border-red-6" color="red">
			Lost
		</Tag>
	);
};
